import React from 'react';
import { Pagination } from 'react-admin';

export const ListPagination = props => {
  if (props.total > 0) {
    return (
      <Pagination
        rowsPerPageOptions={props.total < 25 ? [] : [5, 10, 25]}
        {...props}
      />
    );
  } else {
    return <></>;
  }
};
